import UserStatus from '../UserStatus';
import {DisableUserButton, EditUserButton, EnableUserButton, SetUserPasswordButton} from '../containers';
import React, {PropTypes} from 'react';

export default function UserListRowActions({user}) {
  return (
    <div className="btn-group btn-group-xs">
      <EditUserButton user={user} />
      {user.get('status') === UserStatus.enabled ? <DisableUserButton user={user} /> : <EnableUserButton user={user} />}
      <SetUserPasswordButton user={user} />
    </div>
  );
}

UserListRowActions.propTypes = {
  user: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/features/users/components/UserListRowActions.js